import { CustomElement, resolve } from 'aurelia';
import { AdminService, CalendarService, DiagnosticsService } from '../../services';
import template from './admin-log.html';

// The admin diagnostics log shown under the calendar when the log is expanded. Renders only for
// an admin with the log toggled open. The toolbar's Retry/Clear and the entries live in
// AdminService/DiagnosticsService; Retry's disabled state tracks CalendarService load flags. The
// log-content element is captured into DiagnosticsService so it can auto-scroll to new entries.
export class AdminLogElement {
  readonly admin: AdminService = resolve(AdminService);
  readonly diagnostics: DiagnosticsService = resolve(DiagnosticsService);
  readonly calendar: CalendarService = resolve(CalendarService);
}

export const AdminLog = CustomElement.define({
  name: 'admin-log',
  template,
  // Render in place so the .log-section keeps its position inside the center panel flow.
  containerless: true
}, AdminLogElement);
